export const connectorFormats = ['SOCKET', 'CABLE'] as const;
export type ConnectorFormat = (typeof connectorFormats)[number];
